import Vue from 'vue';
import Cookie from 'js-cookie';
import './styles/app.styl';
import VeeValidate from 'vee-validate';
import AppIcon from '@/components/AppIcon';
import Store from './store';
import App from './App.vue';
import './registerServiceWorker';

Vue.use(VeeValidate, { inject: false });
Vue.config.productionTip = false;

Vue.component('AppIcon', AppIcon);
Vue.directive('load', (el, binding) => {
  el.classList.toggle('is-loading', binding.value);
  el.disabled = binding.value;
});

Vue.prototype.$notify = (...args) => Store.notify(...args);

const login = async (token) => {
  try {
    Store.isLoggingIn = true;
    const api = await import('./api');
    const { data } = await api.default.query({
      query: require('@/graphql/Auth.gql').Me,
      variables: {
        token
      }
    });
    Store.setUser(data.user);
    Store.setToken(token);
    Cookie.set('auth', token, { expires: 30 });
  } catch (err) {
    Store.notify(err.message, 'error');
  } finally {
    Store.isLoggingIn = false;
  }
};

const token = Cookie.get('auth');
if (token) {
  login(token);
}

new Vue({
  render: h => h(App)
}).$mount('#app');
